/**
 * <wifi-stat-counter target="12000" duration="1200"> — counts up once, when visible.
 * No external library; respects prefers-reduced-motion by jumping straight to the target.
 */
class WifiStatCounter extends HTMLElement {
  connectedCallback() {
    this.target = Number(this.getAttribute('target')) || 0;
    this.duration = Number(this.getAttribute('duration')) || 1200;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.reduced || !('IntersectionObserver' in window)) {
      this.textContent = this.target.toLocaleString();
      return;
    }

    this.textContent = '0';
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.animate();
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(this);
  }

  animate() {
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min((now - start) / this.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.textContent = Math.round(eased * this.target).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
}

customElements.define('wifi-stat-counter', WifiStatCounter);
